import { compose } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { type ComponentType } from 'react';
import { scrollToTop } from 'utils/utils';
import Pagination from '../Pagination';
import {
  byInitialPage,
  byTotalPages,
  pushPageParameterBy,
} from '../../modules/resultList';

const SCROLL_TO_TOP_DURATION = 300;

const mapStateToProps = (state, ownProps) => ({
  initialPage: byInitialPage(state),
  pageCount: byTotalPages(state),
  ...ownProps,
});

const mapDispatchToProps = (_, { history }: any) => ({
  onChange: (page: any) => {
    pushPageParameterBy(history, page + 1);
    scrollToTop(SCROLL_TO_TOP_DURATION);
  },
});

const PaginationContainer = compose<ComponentType>(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(Pagination);

export default PaginationContainer;
